import React from 'react';
import { Helmet } from 'react-helmet-async';

interface SEOProps {
  title?: string;
  description?: string;
  image?: string;
  url?: string;
  type?: string;
  keywords?: string;
  author?: string;
  publishedTime?: string;
  modifiedTime?: string;
  structuredData?: object;
}

const SEO: React.FC<SEOProps> = ({
  title = "glide - Das Schweizer Langlauf-Magazin",
  description = "glide ist das Schweizer Langlauf-Magazin: Reportagen, Loipen, Ausrüstung, Tests und Geschichten aus der Schweizer Langlaufwelt.",
  image = "https://glide.swiss/lovable-uploads/60ad6a07-60fb-4307-af5b-b952dcccde70.png",
  url = "https://glide.swiss",
  type = "website",
  keywords = "Langlauf, Schweiz, Nordischer Skisport, Skilanglauf, Loipen, Cross Country Skiing, glide Magazin",
  author = "Rothus Medien AG",
  publishedTime,
  modifiedTime,
  structuredData
}) => {
  const fullTitle = title.includes('glide') ? title : `${title} | glide - Das Schweizer Langlauf-Magazin`;

  return (
    <>
      <Helmet>
        {/* Basic SEO */}
        <title>{fullTitle}</title>
        <meta name="description" content={description} />
        <meta name="keywords" content={keywords} />
        <meta name="author" content={author} />
        <link rel="canonical" href={url} />

        {/* Open Graph / Facebook */}
        <meta property="og:type" content={type} />
        <meta property="og:title" content={fullTitle} />
        <meta property="og:description" content={description} />
        <meta property="og:image" content={image} />
        <meta property="og:url" content={url} />
        <meta property="og:site_name" content="glide - Das Schweizer Langlauf-Magazin" />
        <meta property="og:locale" content="de_CH" />
        <meta property="og:locale:alternate" content="en_US" />

        {/* Twitter */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={fullTitle} />
        <meta name="twitter:description" content={description} />
        <meta name="twitter:image" content={image} />
        <meta name="twitter:site" content="@glide.swiss" />
        <meta name="twitter:creator" content="@glide.swiss" />

        {/* Article specific */}
        {type === 'article' && publishedTime && (
          <meta property="article:published_time" content={publishedTime} />
        )}
        {type === 'article' && modifiedTime && (
          <meta property="article:modified_time" content={modifiedTime} />
        )}
        {type === 'article' && (
          <meta property="article:section" content="Langlauf" />
        )}

        {/* Additional meta tags */}
        <meta name="robots" content="index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1" />
        <meta name="language" content="DE" />
        <meta name="revisit-after" content="7 days" />
        <meta name="rating" content="general" />
        <meta name="distribution" content="global" />

        {/* Structured Data */}
        {structuredData && (
          <script type="application/ld+json">
            {JSON.stringify(structuredData)}
          </script>
        )}
      </Helmet>
    </>
  );
};

export default SEO;